import { Injectable } from '@angular/core';
import { Query } from './query.model';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class QueryService {
  queryChanged = new Subject<Query>();

  private query: Query = new Query('Paris', 0, {collect: true, treatment: true}, []);

  constructor() { }

  getQuery() {
    return this.query;
  }

  updateQuery(newQuery: Query) {
    this.query = newQuery;
    this.queryChanged.next(this.query);
  }


}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/query.service.ts